import { Bell, Menu } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function AppTopbar({
  title,
  subtitle,
  onMenuClick,
}) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let t;
    const load = async () => {
      try {
        const { data } = await api.get("/notifications/unread-count");
        setUnread(data.unread || 0);
      } catch { }
    };
    load();
    t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-[#0B6936]/20 bg-[#0B6936] px-4 md:px-6 lg:px-8">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="rounded-md p-2 text-white hover:bg-white/10 lg:hidden"
        >
          <Menu size={22} />
        </button>

        <div>
          <h1 className="text-lg md:text-xl font-display font-semibold text-white leading-tight">
            {title}
          </h1>

          {subtitle && (
            <p className="hidden sm:block text-xs text-white/80 mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-3">
        <Link
          to="/app/notifications"
          data-testid="topbar-notifications"
          className="relative p-2 rounded-md hover:bg-white/10 text-white"
        >
          <Bell size={18} />
          {unread > 0 && (
            <span className="absolute top-1 right-1 min-w-[16px] h-4 px-1 rounded-full bg-[#DC2626] text-white text-[10px] font-semibold flex items-center justify-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </Link>
      </div>
    </header>
  );
}
